var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "v-icon__svg",
      attrs: { width: "24px", height: "24px", viewBox: "0 0 24 24" },
    },
    [
      _c("path", {
        attrs: {
          d: "M14,3 C14.5522847,3 15,3.44771525 15,4 L15,5.25 L18,3 L18,9 L15,6.75 L15,8 C15,8.55228475 14.5522847,9 14,9 L8,9 C7.44771525,9 7,8.55228475 7,8 L7,4 C7,3.44771525 7.44771525,3 8,3 L14,3 Z",
        },
      }),
      _c("g", { attrs: { transform: "translate(7.000000, 12.000000)" } }, [
        _c("path", {
          attrs: {
            d: "M4.995,-1 C1.68335864,-1 -1,1.68707007 -1,5 C-1,8.31292993 1.68335864,11 4.995,11 C8.31135678,11 11,8.3132123 11,5 C11,1.6867877 8.31135678,-1 4.995,-1 Z M4.995,1 C7.20709625,1 9,2.79166641 9,5 C9,7.20833359 7.20709625,9 4.995,9 C2.78854743,9 1,7.20897878 1,5 C1,2.79102122 2.78854743,1 4.995,1 Z",
          },
        }),
        _c("path", {
          attrs: {
            d: "M6.75,6 C7.44166667,6 8,5.44166667 8,4.75 C8,4.05833333 7.44166667,3.5 6.75,3.5 C6.05833333,3.5 5.5,4.05833333 5.5,4.75 C5.5,5.44166667 6.05833333,6 6.75,6 Z",
          },
        }),
        _c("path", {
          attrs: {
            d: "M3.25,6 C3.94166667,6 4.5,5.44166667 4.5,4.75 C4.5,4.05833333 3.94166667,3.5 3.25,3.5 C2.55833333,3.5 2,4.05833333 2,4.75 C2,5.44166667 2.55833333,6 3.25,6 Z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }